<template>
	<progress-bar class="progress-achievements" text="" :value="levelProgress" />
</template>

<script>
import { achievementsToNextRankLevel } from 'staticData';

export default {
	props: ['user'],
	computed: {
		levelProgress () {
			const progress = this.user.unlockedAchievementCount / achievementsToNextRankLevel[this.user.rankLevel];
			return progress;
		},
	},
};
</script>
